import { createFileRoute } from "@tanstack/react-router";
import ApplyAdmissionPage from "@project/user/pages/admission/apply-admission";

export const Route = createFileRoute("/_user/_admission/apply-admission")({
  head: () => ({
    meta: [
      { title: "Apply for Admission — Jivandhara Vruddhashram" },
      {
        name: "description",
        content:
          "Submit an admission application to admit an elderly person to our Vruddhashram. Family members and well-wishers welcome.",
      },
      { property: "og:title", content: "Apply for Admission — Jivandhara" },
      {
        property: "og:description",
        content: "Submit an admission application for the Vruddhashram.",
      },
    ],
  }),
  component: ApplyAdmissionPage,
});
